/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type BatchUpdateStockForSkuInput = {
  sku: string;
  stockUpdates: Array<StockUpdate>;
};

export type InventoryChangeMetadata = {
  additionalOutboundReason?: string | null | undefined;
  desadv?: string | null | undefined;
  expectedQuantity?: string | null | undefined;
  expirationDate?: string | null | undefined;
  imageUrls?: string | null | undefined;
  inboundingMethod?: string | null | undefined;
  inboundingUnit?: string | null | undefined;
  lotNumber?: string | null | undefined;
  orderId?: string | null | undefined;
  scannedEAN?: string | null | undefined;
  sscc?: string | null | undefined;
  stockCorrectionId?: string | null | undefined;
};

export type InventoryChangeReason =
  | "CORRECTION"
  | "CORRECTION_BAKING_INGREDIENTS"
  | "CORRECTION_BREAK_IN"
  | "CORRECTION_ORDER_CANCELLATION_RETURN"
  | "EOY_INVENTORY_CHECK"
  | "EOY_INVENTORY_RECOUNT"
  | "EXTRA_CHECK"
  | "INBOUND_BULK"
  | "INBOUND_GOODS_RECEIVED"
  | "INBOUND_ORDER_CANCELLATION"
  | "INBOUND_STOCK_TRANSFER"
  | "INBOUND_SURPRISE_BAG"
  | "LOW_STOCK_CHECK"
  | "ORDER_CANCELLED"
  | "ORDER_CREATED"
  | "OUTBOUND_DELIVERY_PRODUCT_DAMAGED"
  | "OUTBOUND_DELIVERY_PRODUCT_EXPIRED"
  | "OUTBOUND_EQUIPMENT_FAILURE"
  | "OUTBOUND_HUB_CLOSURE"
  | "OUTBOUND_ORDER_CANCELLATION_NOT_RETURNED"
  | "OUTBOUND_ORDER_CANCELLATION_NOT_SELLABLE"
  | "OUTBOUND_PRODUCT_DAMAGED"
  | "OUTBOUND_PRODUCT_EXPIRED"
  | "OUTBOUND_STOCK_TRANSFER"
  | "OUTBOUND_SURPRISE_BAG"
  | "OUTBOUND_TOO_GOOD_TO_GO"
  | "OUT_OF_STOCK_CHECK"
  | "POST_INBOUND_CORRECTION"
  | "PRODUCT_RECALL"
  | "REQUESTED_FROM_INBOUND_CORRECTION"
  | "ROLLING_INVENTORY_CHECK"
  | "UNSPECIFIED";

export type ProductStockUpdateParams = {
  desadv?: string | null | undefined;
  expectedQuantity?: string | null | undefined;
  inboundingMethod?: string | null | undefined;
  inboundingUnit?: string | null | undefined;
  orderId?: string | null | undefined;
  quantityDelta: number;
  reason: InventoryChangeReason;
  scannedEAN?: string | null | undefined;
  sscc?: string | null | undefined;
  stockCorrectionId?: string | null | undefined;
  transactionId: string;
};

export type StockUpdate = {
  metadata?: InventoryChangeMetadata | null | undefined;
  quantityDelta: number;
  reason: InventoryChangeReason;
};

export type UpdateProductStockByDeltaAndMultipleReasonsInput = {
  sku: string;
  stockUpdates: Array<ProductStockUpdateParams>;
};

export type UpdateProductStockByDeltaAndMultipleReasonsMutationVariables = Exact<{
  updateProductStockByDeltaAndMultipleReasonsInput: Types.UpdateProductStockByDeltaAndMultipleReasonsInput;
}>;

export type UpdateProductStockByDeltaAndMultipleReasonsMutation = {
  updateProductStockByDeltaAndMultipleReasons: { updateResults: Array<{ success: boolean }> };
};

export type BatchUpdateStockForSkuMutationVariables = Exact<{
  updateProductStockByDeltaAndMultipleReasonsInput: Types.BatchUpdateStockForSkuInput;
}>;

export type BatchUpdateStockForSkuMutation = { batchUpdateStockForSku: { success: boolean } };

export const UpdateProductStockByDeltaAndMultipleReasonsDocument = gql`
  mutation updateProductStockByDeltaAndMultipleReasons(
    $updateProductStockByDeltaAndMultipleReasonsInput: UpdateProductStockByDeltaAndMultipleReasonsInput!
  ) {
    updateProductStockByDeltaAndMultipleReasons(
      UpdateProductStockByDeltaAndMultipleReasonsInput: $updateProductStockByDeltaAndMultipleReasonsInput
    ) {
      updateResults {
        success
      }
    }
  }
`;
export type UpdateProductStockByDeltaAndMultipleReasonsMutationFn = Apollo.MutationFunction<
  UpdateProductStockByDeltaAndMultipleReasonsMutation,
  UpdateProductStockByDeltaAndMultipleReasonsMutationVariables
>;

/**
 * __useUpdateProductStockByDeltaAndMultipleReasonsMutation__
 *
 * To run a mutation, you first call `useUpdateProductStockByDeltaAndMultipleReasonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductStockByDeltaAndMultipleReasonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductStockByDeltaAndMultipleReasonsMutation, { data, loading, error }] = useUpdateProductStockByDeltaAndMultipleReasonsMutation({
 *   variables: {
 *      updateProductStockByDeltaAndMultipleReasonsInput: // value for 'updateProductStockByDeltaAndMultipleReasonsInput'
 *   },
 * });
 */
export function useUpdateProductStockByDeltaAndMultipleReasonsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProductStockByDeltaAndMultipleReasonsMutation,
    UpdateProductStockByDeltaAndMultipleReasonsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProductStockByDeltaAndMultipleReasonsMutation,
    UpdateProductStockByDeltaAndMultipleReasonsMutationVariables
  >(UpdateProductStockByDeltaAndMultipleReasonsDocument, options);
}
export type UpdateProductStockByDeltaAndMultipleReasonsMutationHookResult = ReturnType<
  typeof useUpdateProductStockByDeltaAndMultipleReasonsMutation
>;
export type UpdateProductStockByDeltaAndMultipleReasonsMutationResult =
  Apollo.MutationResult<UpdateProductStockByDeltaAndMultipleReasonsMutation>;
export type UpdateProductStockByDeltaAndMultipleReasonsMutationOptions = Apollo.BaseMutationOptions<
  UpdateProductStockByDeltaAndMultipleReasonsMutation,
  UpdateProductStockByDeltaAndMultipleReasonsMutationVariables
>;
export const BatchUpdateStockForSkuDocument = gql`
  mutation batchUpdateStockForSku(
    $updateProductStockByDeltaAndMultipleReasonsInput: BatchUpdateStockForSkuInput!
  ) {
    batchUpdateStockForSku(
      UpdateProductStockByDeltaAndMultipleReasonsInput: $updateProductStockByDeltaAndMultipleReasonsInput
    ) {
      success
    }
  }
`;
export type BatchUpdateStockForSkuMutationFn = Apollo.MutationFunction<
  BatchUpdateStockForSkuMutation,
  BatchUpdateStockForSkuMutationVariables
>;

/**
 * __useBatchUpdateStockForSkuMutation__
 *
 * To run a mutation, you first call `useBatchUpdateStockForSkuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateStockForSkuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateStockForSkuMutation, { data, loading, error }] = useBatchUpdateStockForSkuMutation({
 *   variables: {
 *      updateProductStockByDeltaAndMultipleReasonsInput: // value for 'updateProductStockByDeltaAndMultipleReasonsInput'
 *   },
 * });
 */
export function useBatchUpdateStockForSkuMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BatchUpdateStockForSkuMutation,
    BatchUpdateStockForSkuMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BatchUpdateStockForSkuMutation,
    BatchUpdateStockForSkuMutationVariables
  >(BatchUpdateStockForSkuDocument, options);
}
export type BatchUpdateStockForSkuMutationHookResult = ReturnType<
  typeof useBatchUpdateStockForSkuMutation
>;
export type BatchUpdateStockForSkuMutationResult =
  Apollo.MutationResult<BatchUpdateStockForSkuMutation>;
export type BatchUpdateStockForSkuMutationOptions = Apollo.BaseMutationOptions<
  BatchUpdateStockForSkuMutation,
  BatchUpdateStockForSkuMutationVariables
>;
